<template>
  <v-app
    color="primary "
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <div v-if="page_ready">
      <v-main>
        <!-- alert notification -->
        <notification />
        <AppBar />
        <the-nav-bar />
        <!-- Native-style bottom tab bar on phones -->
        <mobile-bottom-nav v-if="isPhone" />
        <transition name="router_anim" mode="out-in">
          <router-view />
        </transition>
        <!-- <AppFooter class="mt" /> -->
      </v-main>
      <!-- Task reminder popup (scheduled: login, 8AM, 12PM, 3PM) -->
      <task-popup-dialog v-if="canUseTasks" />
      <!-- Task assignment notification popup (polled every 2 minutes) -->
      <task-notification-dialog v-if="canUseTasks" />
      <!-- Field order notification popup (polled every 2 minutes) -->
      <field-job-order-notification-dialog />
      <!-- Floating HTTP request status indicator -->
      <http-status-indicator />
      <!-- Global Quick Actions command palette (Ctrl/Cmd + S) -->
      <quick-actions />
    </div>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppBar from "./components/Layout/appBar.vue";

import Notification from "./components/Notification.vue";
import TheNavBar from "./components/TheNavBar.vue";
import TaskPopupDialog from "./components/Task/TaskPopupDialog.vue";
import TaskNotificationDialog from "./components/Task/TaskNotificationDialog.vue";
import FieldJobOrderNotificationDialog from "./components/FieldJobOrder/FieldJobOrderNotificationDialog.vue";
import HttpStatusIndicator from "./components/Layout/HttpStatusIndicator.vue";
import QuickActions from "./components/Layout/QuickActions.vue";
import MobileBottomNav from "./components/Layout/MobileBottomNav.vue";
import taskNotificationMixin from "./mixins/taskNotificationMixin.js";
import fieldJobOrderNotificationMixin from "./mixins/fieldJobOrderNotificationMixin.js";
export default {
  mixins: [taskNotificationMixin, fieldJobOrderNotificationMixin],
  watch: {
    $route() {
      document.title = this.currentRouteName + " - JMBComputers";
    },
    darkMode(newValue) {
      this.$vuetify.theme.dark = newValue;
    },
    selectedTheme(newTheme) {
      // Update Vuetify's primary color when theme changes
      this.$vuetify.theme.themes.light.primary = newTheme.primary;
      this.$vuetify.theme.themes.dark.primary = newTheme.primary;
    },
    // Trigger task notifications after user logs in; clean up on logout
    user(newUser, oldUser) {
      if (newUser) {
        this.initFieldJobOrderNotifications();
        // Load this user's role-based permissions so role restrictions
        // are enforced (e.g. in the Quick Actions palette), THEN start task
        // notifications — initTaskNotifications gates on appbar.reminders, so
        // it must run after permissions are known.
        this.fetch_user_permissions()
          .catch(() => {})
          .finally(() => this.initTaskNotifications());
      } else if (oldUser && !newUser) {
        // User logged out -- stop polling and clear notification state
        this.cleanupTaskNotifications();
        this.cleanupFieldJobOrderNotifications();
      }
    },
  },
  components: {
    Notification,
    AppBar,
    // AppFooter,
    TheNavBar,
    TaskPopupDialog,
    TaskNotificationDialog,
    FieldJobOrderNotificationDialog,
    HttpStatusIndicator,
    QuickActions,
    MobileBottomNav,
  },
  name: "App",

  data: () => ({
    page_ready: true,
    hide_nav: true,
    hide_top_nav: true,
  }),

  mounted() {
    this.check_user();
    // User may already be restored (via auth/attempt) before this component
    // mounts, so the watcher won't fire -- load permissions here too, then
    // (re)start task notifications once appbar.reminders is known.
    if (this.user) {
      this.fetch_user_permissions()
        .catch(() => {})
        .finally(() => this.initTaskNotifications());
    }
    // Initialize Vuetify dark mode from store
    this.$vuetify.theme.dark = this.darkMode;
    // Initialize Vuetify primary color from selected theme
    this.$vuetify.theme.themes.light.primary = this.selectedTheme.primary;
    this.$vuetify.theme.themes.dark.primary = this.selectedTheme.primary;
  },
  computed: {
    ...mapGetters({
      darkMode: "theme/darkMode",
      selectedTheme: "theme/selectedTheme",
      user: "auth/user",
      hasPermission: "permission/hasPermission",
    }),
    // My Tasks feature (appbar button + reminder popups) is gated on
    // appbar.reminders, so the global kill-switch turns it all off.
    canUseTasks() {
      return this.hasPermission("appbar.reminders");
    },
    currentRouteName() {
      return this.$route.name;
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  methods: {
    ...mapActions({
      attempt: "auth/attempt",
      fetch_user_permissions: "permission/fetch_user_permissions",
    }),
    async check_user() {
      // var token = localStorage.getItem("token");
      // if (token) {
      //   this.attempt(token).then(() => {
      //     this.$router.push("/");
      //   });
      // }
    },
  },
};
</script>
<style>
.title {
  font-size: 120px;
}
.router_anim-enter {
  opacity: 0;
  transform: translateX(-200px);
}
.router_anim-enter-active {
  transition: all 0.2s ease;
}
.router_anim-leave-to {
  opacity: 0;
  transform: translateX(200px);
}
.router_anim-leave-active {
  transition: all 0.2s ease;
}
/* .page {
  position: fixed;
  width: inherit;
} */
</style>
